import { defineMessages } from 'react-intl';

export const moreAppsControlMessages: {
	moreLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreAppsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appStackLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moreLabel: {
		id: 'search-common.more-apps-control.moreLabel',
		defaultMessage: 'More',
		description:
			'Visible label on the control that reveals the apps which do not fit in the filter row. Kept short because the control also shows a stack of app icons.',
	},
	moreAppsLabel: {
		id: 'search-common.more-apps-control.moreAppsLabel',
		defaultMessage: 'More apps',
		description:
			'Accessible name for the control that reveals the apps which do not fit in the filter row. The visible label is only "More", so the full phrase is spelled out for screen reader users.',
	},
	appStackLabel: {
		id: 'search-common.more-apps-control.appStackLabel',
		defaultMessage: 'Apps not shown',
		description:
			'Accessible name for the stack of app icons previewing which apps are hidden behind the More apps control.',
	},
});
